const dateTimeFormats = {
  en: {
    short: { year: "numeric", month: "short", day: "numeric" },
    shortdt: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      // weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false
    },
    mdhms: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  cs: {
    short: { year: "numeric", month: "long", day: "numeric" },
    shortdt: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      // weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    },
    mdhms: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    },
    mdhm: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }
  },
  sk: {
    short: { year: "numeric", month: "long", day: "numeric" },
    shortdt: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      // weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    },
    mdhms: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    },
    mdhm: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }
  }
};

export default dateTimeFormats;
